import DamagePhotoModal from "./damage-photo-modal";
import DamageFilterModal from "./damage-filter-modal";
import DamageSortModal from "./damage-sort-modal";

import "./damage-modals.scss";


const DamageModals = {
    Photo: DamagePhotoModal,
    Filter: DamageFilterModal,
    Sort: DamageSortModal
}

export default DamageModals;